/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Weekday_2Inputs */

const vi_irrigation_weekday_2 = /** @type {(inputs: Irrigation_Weekday_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`T3`)
};

/**

* @param {Irrigation_Weekday_2Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_weekday_2 = /** @type {((inputs?: Irrigation_Weekday_2Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Weekday_2Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_weekday_2(inputs)
});